import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-ink-800" data-id="element-31" data-mp="x5mwum1ar1re">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-20" data-id="element-32" data-mp="123566dj87izx">
        <div className="text-center" data-id="element-33" data-mp="1pro3jy0qmbd8">
          <SectionLabel data-id="element-34" data-mp="1pspoqvbgwe8o">Preguntas frecuentes</SectionLabel>
          <h2 id="faq-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-35" data-mp="1urtwrimno5xf">
            Antes de agendar
          </h2>
        </div>
        <div className="mt-10 space-y-3" data-id="element-36" data-mp="1l0pi6k0w6n34">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-ink-border bg-ink-card" data-id="element-37" data-mp="28oz3lku718tq" data-mpi={index}>
                <h3 data-id="element-38" data-mp="2or0fnatr54qw">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-ink-border/25" data-id="element-39" data-mp="2oqia1nl79e6b">
                    <span className="text-[15px] font-bold text-white md:text-base" data-id="element-40" data-mp="37ijinhns0isx">
                      {faq.question}
                    </span>
                    <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-greenDeep text-brand-green" data-id="element-41" data-mp="3hduy6270du1q">
                      {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={3} data-id="element-42" data-mp="1i1s6i4o8dtcz" /> : <PlusIcon className="h-4 w-4" strokeWidth={3} data-id="element-43" data-mp="27pxmt4e71drt" />}
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5" data-id="element-44" data-mp="2gqlznvrup834">
                    <p className="border-t border-ink-border pt-4 text-[15px] leading-relaxed text-body" data-id="element-45" data-mp="2gpaxu1hyuaen">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}